import React, { useState, useEffect } from "react";
import { StyledDataGrid } from "../../../common/components/DataGrid/styles";
import { StatusGridContainer } from "./CaseStatusGrid";
import { Grid } from "@mui/material";
import { StyledH3 } from "../../../common/components/Title/styles";
import { StyledButton } from "../../../common/components/Button";
import SetActionButtons from "./SetActionButtons";
import ConfirmationDialog from "../../../common/components/Dialog";
import UpdateFabricationDateDialog from "./UpdateFabricationDateDialog";
import { normalizeDateTime } from "../../../common/helpers/normalizeDateTime";
import PayCaseProgressDialog from "./PayCaseProgressDialog";
import { useSelector } from "react-redux";
import { Chip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import PaymentEmailDialog from "./PaymentEmailDialog";
import UpdateShipmentDateDialog from "./UpdateShipmentDateDialog";
import GeneratePaymentLinkDialog from "./GeneratePaymentLinkDialog";
const SetsProgressTable = ({
  caseDetails,
  getSetsInfo,
  currentSet,
  nextSet,
  setRows,
  handleOpenUpdateNoOfSets,
  getPaymentTransactions,
  modeOfPayment,
  isSubscription,
  onEmailSent,
  onEmailError,
  currentCaseProgress,
  handleSetCurrentCaseProgress,
  handleOpenCommentSection,
}) => {
  console.log(setRows);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [confirmationSubmit, setConfirmationSubmit] = useState(
    () => () => null
  );
  const [openUpdateFabricationDate, setOpenUpdateFabricationDate] =
    useState(false);
  const [openUpdateShipmentDate, setOpenUpdateShipmentDate] = useState(false);

  const [
    openUpdateFabricationDateFromFabricateSet,
    setOpenUpdateFabricationDateFromFabricateSet,
  ] = useState(false);
  const [
    openUpdateShipmentDateFromShipSet,
    setOpenUpdateShipmentDateFromShipSet,
  ] = useState(false);

  const [currentPaymentLink, setCurrentPaymentLink] = useState("");
  const [openGeneratePaymentLink, setOpenGeneratePaymentLink] = useState(false);
  const [openPayCaseProgress, setOpenPayCaseProgress] = useState(false);
  const [openEmailDialog, setOpenEmailDialog] = useState(false);
  const [currentCaseProgressAmount, setCurrentCaseProgressAmount] =
    useState("");
  // const [currentCaseProgressId, setCurrentCaseProgressId] = useState("");

  const user = useSelector((state) => state.user);

  const handleOpenPayCaseProgress = () => {
    setOpenPayCaseProgress(true);
  };

  const handleClosePayCaseProgress = () => {
    setOpenPayCaseProgress(false);
  };

  const handleCloseUpdateShipmentDate = () => {
    setOpenUpdateShipmentDate(false);
  };

  const handleCloseUpdateFabricationDate = () => {
    setOpenUpdateFabricationDate(false);
  };

  const handleCloseGeneratePaymentLink = () => {
    setOpenGeneratePaymentLink(false);
  };

  const handleOpenGeneratePaymentLink = () => {
    setOpenGeneratePaymentLink(true);
  };

  const handleSetPaymentLink = (link) => {
    setCurrentPaymentLink(link);
  };

  const [confirmationTitle, setConfirmationTitle] =
    useState("Confirmation Title");

  // const handleSetCurrentProgressId = (id) => {
  //   setCurrentCaseProgressId(id);
  // };

  const handleSetCurrentProgressAmount = (amount) => {
    setCurrentCaseProgressAmount(amount);
  };

  const handleConfirmationSubmit = (submit) => {
    setConfirmationSubmit(submit);
  };

  const handleConfirmationTitle = (title) => {
    setConfirmationTitle(title);
  };

  const handleShowConfirmation = (params) => {
    setShowConfirmationDialog(params);
  };

  const handleEmailDialogOpen = () => {
    setOpenEmailDialog(true);
  };

  const handleEmailDialogClose = () => {
    setOpenEmailDialog(false);
  };
  const columns = [
    {
      field: "setName",
      headerName: "Sets",
      width: 250,
      renderCell: (params) => {
        return (
          <div>
            <Chip
              label={params.row.setName.split("|")[0]}
              style={{
                marginRight: "5px",
                minWidth: "110px",
                paddingLeft: "1px",
                paddingRight: "1px",
              }}
            />
            <Chip
              variant="outlined"
              label={params.row.setName.split("|")[1]}
              style={{
                minWidth: "110px",
                paddingLeft: "1px",
                paddingRight: "1px",
              }}
            />
          </div>
        );
      },
    },
    {
      field: "setNameForFabrication",
      headerName: "Sets For Fabrication",
      width: 250,
      renderCell: (params) => {
        return (
          <>
            {params?.row?.setNameForFabrication && (
              <div>
                <Chip
                  label={params?.row?.setNameForFabrication.split("|")[0]}
                  style={{
                    marginRight: "5px",
                    minWidth: "110px",
                    paddingLeft: "1px",
                    paddingRight: "1px",
                  }}
                />
                <Chip
                  variant="outlined"
                  label={params?.row?.setNameForFabrication.split("|")[1]}
                  style={{
                    minWidth: "110px",
                    paddingLeft: "1px",
                    paddingRight: "1px",
                  }}
                />
              </div>
            )}
          </>
        );
      },
    },
    {
      field: "dueDate",
      headerName: "Payment Due Date",
      width: 150,
      renderCell: (params) => {
        return [
          <div>
            {params.value == null ? "" : normalizeDateTime(params.value)}
          </div>,
        ];
      },
    },
    {
      field: "fabricationDate",
      headerName: "Fabrication Date",
      width: 150,
      renderCell: (params) => {
        return [
          <div>
            {params.value !== null ? (
              normalizeDateTime(params.value)
            ) : (
              <StyledButton
                onClick={() => {
                  setOpenUpdateFabricationDate(true);
                  handleSetCurrentCaseProgress(params.row);
                }}
                theme="green"
              >
                Update Date
              </StyledButton>
            )}
          </div>,
        ];
      },
    },
    {
      field: "shipmentDate",
      headerName: "Shipment Date",
      width: 150,
      renderCell: (params) => {
        return [
          <div>
            {params.value !== null ? (
              normalizeDateTime(params.value)
            ) : (
              <StyledButton
                onClick={() => {
                  setOpenUpdateShipmentDate(true);
                  handleSetCurrentCaseProgress(params.row);
                }}
                theme="green"
              >
                Update Date
              </StyledButton>
            )}
          </div>,
        ];
      },
    },

    {
      field: "status",
      headerName: "Status",
      width: 250,

      renderCell: (params) => {
        return [
          <div>
            <Chip
              variant="outlined"
              color={params.row.isFabricated ? "success" : "error"}
              label={
                params.row.isFabricated ? (
                  <div>
                    Fabricated <FontAwesomeIcon icon={faCheck} />
                  </div>
                ) : (
                  <div>
                    Fabricated <FontAwesomeIcon icon={faXmark} />
                  </div>
                )
              }
              style={{ marginRight: "5px", minWidth: "115px" }}
            />
            <Chip
              variant="outlined"
              color={params.row.isShipped ? "success" : "error"}
              label={
                params.row.isShipped ? (
                  <div>
                    Shipped <FontAwesomeIcon icon={faCheck} />
                  </div>
                ) : (
                  <div>
                    Shipped <FontAwesomeIcon icon={faXmark} />
                  </div>
                )
              }
              style={{ minWidth: "115px" }}
            />
          </div>,
        ];
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,

      renderCell: (params) => {
        return [
          <SetActionButtons
            modeOfPayment={modeOfPayment}
            isSubscription={isSubscription}
            allSets={setRows}
            setsInfo={params.row}
            getSetsInfo={getSetsInfo}
            onEmailOpen={handleEmailDialogOpen}
            handleConfirmationSubmit={handleConfirmationSubmit}
            handleConfirmationTitle={handleConfirmationTitle}
            handleShowConfirmation={handleShowConfirmation}
            handleSetCurrentCaseProgress={handleSetCurrentCaseProgress}
            handleOpenPayCaseProgress={handleOpenPayCaseProgress}
            handleSetCurrentProgressAmount={handleSetCurrentProgressAmount}
            handleSetPaymentLink={handleSetPaymentLink}
            handleOpenGeneratePaymentLink={handleOpenGeneratePaymentLink}
            caseDetails={caseDetails}
            handleSetOpenUpdateFabricationDate={() =>
              setOpenUpdateFabricationDate(true)
            }
            handleSetOpenUpdateShipmentDate={() =>
              setOpenUpdateShipmentDate(true)
            }
            handleSetOpenUpdateFabricationDateFromFabricateSet={() =>
              setOpenUpdateFabricationDateFromFabricateSet(true)
            }
            handleSetOpenUpdateShipmentDateFromShipSet={() =>
              setOpenUpdateShipmentDateFromShipSet(true)
            }
            handleOpenCommentSection={handleOpenCommentSection}
          />,
        ];
      },
      align: "center",
    },
  ];

  useEffect(() => {
    getSetsInfo();
  }, []);

  return (
    <div>
      <GeneratePaymentLinkDialog
        open={openGeneratePaymentLink}
        onClose={handleCloseGeneratePaymentLink}
        caseId={caseDetails.id}
        caseProgressId={currentCaseProgress?.id}
        currentPaymentLink={currentPaymentLink}
        modeOfPayment={modeOfPayment}
        isSubscription={isSubscription}
      />
      <UpdateFabricationDateDialog
        openUpdateFabricationDate={openUpdateFabricationDate}
        handleCloseUpdateFabricationDate={handleCloseUpdateFabricationDate}
        caseProgressId={currentCaseProgress?.id}
        getSetsInfo={getSetsInfo}
        openUpdateFabricationDateFromFabricateSet={
          openUpdateFabricationDateFromFabricateSet
        }
        handleSetOpenUpdateFabricationDateFromFabricateSet={() =>
          setOpenUpdateFabricationDateFromFabricateSet(false)
        }
      />
      <UpdateShipmentDateDialog
        openUpdateShipmentDate={openUpdateShipmentDate}
        handleCloseUpdateShipmentDate={handleCloseUpdateShipmentDate}
        caseProgressId={currentCaseProgress?.id}
        getSetsInfo={getSetsInfo}
        openUpdateShipmentDateFromShipSet={openUpdateShipmentDateFromShipSet}
        handleSetOpenUpdateShipmentDateFromShipSet={() =>
          setOpenUpdateShipmentDateFromShipSet(true)
        }
      />
      <PaymentEmailDialog
        open={openEmailDialog}
        onClose={handleEmailDialogClose}
        caseProgressId={currentCaseProgress?.id}
        onEmailSent={onEmailSent}
        onEmailError={onEmailError}
        isSubscription={isSubscription}
      />
      <PayCaseProgressDialog
        openPayCaseProgress={openPayCaseProgress}
        handleClosePayCaseProgress={handleClosePayCaseProgress}
        caseId={caseDetails?.id}
        caseProgressId={currentCaseProgress?.id}
        refresh={getSetsInfo}
        getPaymentTransactions={getPaymentTransactions}
        amountDue={currentCaseProgressAmount}
      />
      <StyledH3 theme="lightpurple">Fabrication and Shipment</StyledH3>
      <StatusGridContainer>
        <Grid
          container
          spacing={0}
          style={{
            padding: "5px",
            paddingTop: "12px",
            paddingBottom: "12px",
            borderRadius: "5px",
            fontSize: "14px",
            fontFamily: "Inter",
          }}
        >
          <Grid item md={4}>
            Total Sets
          </Grid>
          <Grid item md={8} style={{ fontWeight: 600 }}>
            {caseDetails.noOfSetsUpper + caseDetails.noOfSetsLower}
          </Grid>
        </Grid>
        <Grid
          height="50px"
          container
          spacing={0}
          style={{
            backgroundColor: "#F0F0F0",

            padding: "5px",
            display: "flex",
            alignItems: "center",
            borderRadius: "5px",
            fontSize: "14px",
            fontFamily: "Inter",
          }}
        >
          <Grid item md={4}>
            No. of Sets
          </Grid>
          <Grid item md={3} style={{ fontWeight: 600 }}>
            <Chip
              label={"Upper: " + caseDetails.noOfSetsUpper}
              style={{ marginRight: "5px", minWidth: "120px" }}
            />
            <Chip
              variant="outlined"
              label={"Lower: " + caseDetails.noOfSetsLower}
              style={{ minWidth: "120px" }}
            />
          </Grid>
          <Grid item md={5}>
            {caseDetails.status === "Design approved" &&
            user.roles.includes("Operations") ? (
              <StyledButton
                onClick={() => handleOpenUpdateNoOfSets()}
                theme="green"
              >
                Edit No. of Sets
              </StyledButton>
            ) : null}
          </Grid>
        </Grid>

        <Grid
          container
          spacing={0}
          style={{
            padding: "5px",
            paddingTop: "12px",
            paddingBottom: "12px",
            borderRadius: "5px",
            fontSize: "14px",
            fontFamily: "Inter",
          }}
        >
          <Grid item md={4}>
            Current Set
          </Grid>
          <Grid item md={8} style={{ fontWeight: 600 }}>
            {currentSet != null ? (
              <>
                <Chip
                  label={currentSet.split("|")[0]}
                  style={{ marginRight: "5px", minWidth: "120px" }}
                />
                <Chip
                  variant="outlined"
                  label={currentSet.split("|")[1]}
                  style={{ minWidth: "120px" }}
                />
              </>
            ) : null}
          </Grid>
        </Grid>

        <Grid
          container
          spacing={0}
          style={{
            backgroundColor: "#F0F0F0",
            padding: "5px",
            paddingTop: "12px",
            paddingBottom: "12px",
            borderRadius: "5px",
            fontSize: "14px",
            fontFamily: "Inter",
          }}
        >
          <Grid item md={4}>
            Next Set
          </Grid>
          <Grid item md={8} style={{ fontWeight: 600 }}>
            {nextSet != null ? (
              <>
                <Chip
                  label={nextSet.split("|")[0]}
                  style={{ marginRight: "5px", minWidth: "120px" }}
                />
                <Chip
                  variant="outlined"
                  label={nextSet.split("|")[1]}
                  style={{ minWidth: "120px" }}
                />
              </>
            ) : null}
          </Grid>
        </Grid>
      </StatusGridContainer>
      <StyledDataGrid
        sx={{ overflowX: "scroll" }}
        autoHeight
        rows={setRows}
        columns={columns}
        pageSize={50}
        rowsPerPageOptions={[]}
      />
      <ConfirmationDialog
        open={showConfirmationDialog}
        handleClose={() => setShowConfirmationDialog(false)}
        submit={confirmationSubmit}
        title={confirmationTitle}
      />
    </div>
  );
};

export default SetsProgressTable;
